import { BODY_SM_SM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const EmptyStateWrapper = styled.div`
    display: flex;
    width: 100%;
    height: 132px;
    padding: var(--spacing-md, 24px) 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-2xs, 4px);
    align-self: stretch;
`;

export const EmptyStateText = styled.div`
    width: 100%;
    color: var(--colors-text-body, #50566e);
    text-align: center;
    font-size: 14px !important;
    white-space: normal;
    ${BODY_SM_SM_STYLES};
`;
